import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Header from '../main/Header';
import Sidebar from '../main/Sidebar';
import Dashboard from '../pages/Dashboard';
import Statistics from '../pages/Statistics';
import Settings from '../pages/Settings';
import Login from '../../auth/Login';
import AddProduct from '../pages/AddProduct';
import AddBrand from '../pages/AddBrand';
import Orders from '../pages/Orders';
import EditCoupons from '../pages/EditCoupons';
import AddCoupon from '../pages/AddCoupon';
import AddCategory from '../pages/AddCategory';
import AllProducts from '../pages/AllProducts';
import AddSubCategory from '../pages/AddSubCategory';
import OrderDetails from '../pages/OrderDetails';
import Users from '../pages/Users';
import ContactUs from '../pages/ContactUs';
import AddAccessories from '../pages/AddAccessories';
import AddAccessoriesCategory from '../pages/AddAccessoriesCategory';
import AddModels from '../pages/AddModels';
import AllAccessories from '../pages/AllAccessories';
import EditAccessories from '../pages/EditAccessories';
import EditProducts from '../pages/EditProducts';
import PrivateRoute from '../PrivateRoute';
import ReOrderCategory from '../pages/ReOrderCategory'; 

function MainLayout() {
  const location = useLocation();
  const isLoginPage = location.pathname === '/';

  useEffect(() => {
    if (isLoginPage) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isLoginPage]);

  return (
    <section className="flex flex-col">
      <Header />
      <section className="flex gap-[40px]">
        {!isLoginPage && <Sidebar />}
        <section
          className={`w-full h-[93.9vh] ${!isLoginPage ? 'pr-[50px] overflow-y-scroll' : ''}`}
        >
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/statistics" element={<PrivateRoute><Statistics /></PrivateRoute>} />
            <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
            <Route path="/addProduct" element={<PrivateRoute><AddProduct /></PrivateRoute>} />
            <Route path="/addBrand" element={<PrivateRoute><AddBrand /></PrivateRoute>} />
            <Route path="/orders" element={<PrivateRoute><Orders /></PrivateRoute>} />
            <Route path="/editCoupons" element={<PrivateRoute><EditCoupons /></PrivateRoute>} />
            <Route path="/Reordercategoryr" element={<PrivateRoute><ReOrderCategory /></PrivateRoute>} />
            <Route path="/addCoupon" element={<PrivateRoute><AddCoupon /></PrivateRoute>} />
            <Route path="/addCategory" element={<PrivateRoute><AddCategory /></PrivateRoute>} />
            <Route path="/allProducts" element={<PrivateRoute><AllProducts /></PrivateRoute>} />
            <Route path="/subCategory" element={<PrivateRoute><AddSubCategory /></PrivateRoute>} />
            <Route path="/orderDetails/:id" element={<PrivateRoute><OrderDetails /></PrivateRoute>} />
            <Route path="/contact" element={<PrivateRoute><ContactUs /></PrivateRoute>} />
            <Route path="/users" element={<PrivateRoute><Users /></PrivateRoute>} />
            <Route path="/addaccessories" element={<PrivateRoute><AddAccessories /></PrivateRoute>} />
            <Route path="/addmodel" element={<PrivateRoute><AddModels /></PrivateRoute>} />
            <Route path="/addaccessoriescategory" element={<PrivateRoute><AddAccessoriesCategory /></PrivateRoute>} />
            <Route path="/allAccessories" element={<PrivateRoute><AllAccessories /></PrivateRoute>} />
            <Route path="/editAccessories/:id" element={<PrivateRoute><EditAccessories /></PrivateRoute>} />
            <Route path="/editProduct/:id" element={<PrivateRoute><EditProducts /></PrivateRoute>} />
          </Routes>
        </section>
      </section>
    </section>
  );
}

export default MainLayout;
